import { Menu as MuiMenu } from "@mui/material";
import { type ReactNode, type SyntheticEvent } from "react";

type MenuPosition = "default" | "top-end";

export type MenuProps = {
  anchorEl: Element | null;
  open: boolean;
  onClose: (event: SyntheticEvent, reason?: string) => void;
  children: ReactNode;
  id?: string;
  triggerId: string;
  dir?: "ltr" | "rtl";
  disableScrollLock?: boolean;
  position?: MenuPosition;
};

export function Menu({
  anchorEl,
  open,
  onClose,
  children,
  id,
  triggerId,
  dir,
  disableScrollLock,
  position = "default",
}: MenuProps) {
  const isTopEndPreset = position === "top-end";

  return (
    <MuiMenu
      id={id}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      dir={dir}
      disableScrollLock={disableScrollLock}
      slotProps={{
        list: {
          dense: true,
          "aria-labelledby": triggerId,
        },
      }}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "var(--radius-2xl)",
          boxShadow:
            "0px 1px 8px 0px rgba(56, 56, 81, 0.04), 0px 4px 10px 0px rgba(56, 56, 81, 0.04)",
        },
      }}
      transformOrigin={
        isTopEndPreset ? { horizontal: "right", vertical: "bottom" } : undefined
      }
      anchorOrigin={
        isTopEndPreset ? { horizontal: "right", vertical: "top" } : undefined
      }
    >
      {children}
    </MuiMenu>
  );
}
